import { Injectable } from '@angular/core';
import { CsrfService } from './csrf.service';
import { PostHogService } from './posthog.service';

@Injectable({
  providedIn: 'root'
})
export class AppInitializerService {

  constructor(
    private csrfService: CsrfService,
    private posthog: PostHogService
  ) {}

  /**
   * Initialize the application
   */
  async initializeApp(): Promise<void> {

    // Analytics first and synchronously, so that anything failing during the
    // (awaited) CSRF fetch below is still captured. init() is inert without a
    // configured key and never throws.
    this.posthog.init();

    try {
      // Always fetch CSRF token on app startup (supports both authenticated and anonymous users)
      
      const token = await this.csrfService.fetchToken();
      if (token) {
      } else {
      }
      
    } catch (error) {
      console.error('❌ [APP_INIT] Application initialization failed:', error);
      // Don't block app startup, just log the error
    }
  }
}

/**
 * Factory function for APP_INITIALIZER
 */
export function initializeAppFactory(appInitializer: AppInitializerService): () => Promise<void> {
  return () => appInitializer.initializeApp();
}